import {useStore} from "vuex";
import {computed} from "vue";

export default function UseAddElement() {

  const store = useStore()

  const filterValue = computed({
    get: () => store.state.elements.searchItems.addElementFilterItemsValue,
    set: newVal => store.commit('elements/setAddElementFilterItemsValue', newVal)
  })

  return {
    freeElements: computed(() => store.getters['elements/getFreeElements']),
    isAddElementLoading: computed(() => store.state.elements.loadStatuses.isAddElementLoading),
    addElement: elementForm => store.dispatch('elements/addElement', elementForm),
    getUnitValueByCode: code => store.getters["elements/getUnitValueByCode"](code),
    errors: computed(() => store.state.elements.errors),
    clearValueError: () => store.commit('elements/setErrors', {value: undefined}),
    filterValue
  }
}
